import { authLastName } from './AuthStore';

export const updateAuthLastName = (value) => authLastName.update((oldValue) => value);
